var exports = {
  "kL": "container__IRfyUN",
  "iE": "leadingIcon__3P6lVT",
  "CJ": "linkIndicator__7Yrb7T",
  "bQ": "linkOverlay__HlpFwW",
};

module.exports = exports;
